import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ui-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleComponent),
            multi: true,
        }],
    animations: [
        trigger('toggleCircle', [
            state('true', style({ transform: 'translateX(25px)' })),
            state('false', style({ transform: 'translateX(0px)' })),
            transition('false <=> true', animate('150ms ease-in')),
        ]),
        trigger('toggleTrack', [
            state('true', style({ backgroundColor: '#F59C00' })),
            state('false', style({ backgroundColor: '#EEE' })),
            transition('false <=> true', animate('300ms linear')),
        ]),
    ],
    standalone: false
})
export class ToggleComponent {
  @Input('p-id') id: string;
  @Input('p-label') label: string;

  public checked: boolean = false;

  toggle() {
    this.checked = !this.checked;
    this.onChangeCallback(this.checked);
  }

  public onChangeCallback(value: any): void {
    this.writeValue(value);
  };
  
  public onTouchedCallback(value: any) {
    this.writeValue(value);
  };
  
  public writeValue(newValue: boolean) {
    this.checked = newValue;
  }

  public registerOnChange(onChangeCallback: any): void {
    this.onChangeCallback = onChangeCallback;
  }

  public registerOnTouched(onTouchedCallback: any): void {
    this.onTouchedCallback = onTouchedCallback;
  }
}